import styled from 'styled-components';
import { isAndroid, isMobile, isTablet } from 'react-device-detect';
import { isNotStandaloneMobilePWA } from '../../../../utils/mobileSupported';
import { getResponsiveValue } from '../../../../utils/globalMethods';
import { CheckoutTooltipTopPosConditions, CheckoutTooltipTopPosConditionsTablet } from './conditions';
import { Tooltip } from '..';

export const CHECK_OUT = {
  TOOLTIP: styled(Tooltip)`
    width: 360px;
    bottom: ${({ $windowHeight }) =>
      isNotStandaloneMobilePWA
        ? `${getResponsiveValue({
            windowHeight: $windowHeight,
            conditions: isTablet ? CheckoutTooltipTopPosConditionsTablet : CheckoutTooltipTopPosConditions,
            defaultValue: isTablet ? 24 : 36,
          })}dvh`
        : isMobile && !isTablet
          ? '190px'
          : '160px'};
    right: ${`calc(${isTablet ? 49 : isMobile ? (isAndroid ? 43 : 39) : 50}dvw - 595px)`};
    z-index: 100;
  `,
};

